/*
 * Dezente Scroll-Animationen wie im Prototyp (.rvup): Elemente unterhalb des sichtbaren Bereichs fahren beim
 * Hineinscrollen leicht von unten ein, Geschwister nacheinander. Was beim Laden schon zu sehen ist, bleibt stehen
 * (kein Aufblitzen, LCP unberührt). Ohne JavaScript oder bei prefers-reduced-motion passiert nichts.
 * Produktraster und Überschriften animiert Impact selbst (stagger_products_apparition, heading_apparition).
 */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Gruppen: Elemente einer Gruppe bekommen eine Verzögerung nach ihrer Position (--kik-i)
  const GRUPPEN = [
    '.kik-kategorien .kik-kachel',
    '.kik-kollektionen .kik-kol',
    '.kik-pickup__intro > *',
    '.kik-pickup__step',
    '.kik-pickup__store',
    '.kik-community__head > *',
    '.kik-community__item',
    '.kik-store__visual',
    '.kik-store__cc-title',
    '.kik-store__steps li',
    '.kik-store__free',
    '.kik-store__only > *',
    '.kik-store__faq > *',
    '.kik-einsendung__steps li',
    '.product-info .kik-vorteile__item'
  ];

  // Absicherung: Liefert der Observer nichts (manche eingebetteten Ansichten), wird alles sofort gezeigt.
  let observerLebt = false;
  const alleZeigen = () => document.querySelectorAll('[data-kik-reveal]:not(.is-in)').forEach((el) => el.classList.add('is-in'));
  const imBild = () => {
    document.querySelectorAll('[data-kik-reveal]:not(.is-in)').forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });
  };
  let scrollPlan = 0;
  window.addEventListener('scroll', () => {
    if (scrollPlan) return;
    scrollPlan = window.setTimeout(() => { scrollPlan = 0; imBild(); }, 250);
  }, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    observerLebt = true;
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -6% 0px' });

  const vorbereiten = (root = document) => {
    GRUPPEN.forEach((selektor) => {
      const zaehler = new Map();
      root.querySelectorAll(selektor).forEach((el) => {
        if (el.hasAttribute('data-kik-reveal')) return;
        const eltern = el.parentElement;
        const i = zaehler.get(eltern) || 0;
        zaehler.set(eltern, i + 1);
        // Schon sichtbar beim Laden: nicht animieren
        if (el.getBoundingClientRect().top < window.innerHeight) return;
        el.setAttribute('data-kik-reveal', '');
        el.style.setProperty('--kik-i', String(Math.min(i, 6)));
        observer.observe(el);
      });
    });
  };

  const start = () => {
    vorbereiten();
    window.setTimeout(() => { if (!observerLebt) alleZeigen(); }, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme-Editor: neu geladene Sections ebenfalls vorbereiten
  document.addEventListener('shopify:section:load', (event) => vorbereiten(event.target));
})();
